import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  OnInit,
  OnDestroy,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  NgZone
} from '@angular/core';
import { SvgProvider } from '../../providers/svg/svg';
import { jQuery } from 'jquery/dist/jquery';
import * as $ from 'jquery';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { BaseFlavors } from '../../models/models';

//we start at the left
enum RadarIndex {
  INDEX_SOUR,
  INDEX_BITTER,
  INDEX_HOPPY,
  INDEX_FRUITY,
  INDEX_MALTY,
  INDEX_SWEET
}

@Component({
  selector: 'beer-spider',
  templateUrl: 'beer-spider.html',
  styleUrls: ['./beer-spider.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})

export class BeerSpiderComponent  implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  @Input() baseFlavors: BaseFlavors | undefined;

  updateSubscription;

  ngOnChanges(changes: SimpleChanges) {
    // Because the Sibling created a NEW object reference,
    // this function fires every time a slider moves.
    console.log("BeerSpiderComponent.ngOnChanges called with init done = " + this.initDone);
    if (changes['baseFlavors'] && this.baseFlavors) {
      this.drawSvg();
    }
  }

  @ViewChild('spiderCanvas') spiderCanvas: ElementRef;
  @ViewChild('svgHexagons') svgHexagonsRef: ElementRef;
  @ViewChild('svgSpiderContours') svgSpiderContoursRef: ElementRef;
  @ViewChild('svgSpiderContents') svgSpiderContentsRef: ElementRef;
  @ViewChild('svgSpiderTouchOverlay') svgSpiderTouchOverlayRef: ElementRef;

  _CANVAS: any;
  _CONTEXT: any;

  svgHexagons: any;
  svgSpiderContours: any;
  svgSpiderContents: any;
  svgSpiderTouchOverlay: any;

  initDone: boolean = false;

  spiderWidth: number = window.innerWidth;
  spiderHeight: number = window.innerWidth;
  middleX: number = 0;
  middleY: number = 0;

  points: Array<any> = [];

  w: number = 0;
  h: number = 0;

  //colorIndex: number = 0;

  colorStr: String = '';

  colors: Array<any> = [];

  values: any = {};

  public updateSpiderSubscription: any;

  constructor(private svgProvider: SvgProvider, private events: AppEventService, private translateService: TranslateService,
    private ngZone: NgZone
  ) {
    this.initDone = false;

  //  this._color = -1;

    this.initPoints();

    this.initValues();

    this.updateSpiderSubscription = (spiderEvent: any) => {
      //redraw the spider
      //check to see if this is enough!
      this.initPoints();
      this.initializeView();
      this.initCanvas();
      this.clearCanvas();
      //this.drawSvg();
    };

  }

  ngOnDestroy() {
    this.events.unsubscribe("update:spider", this.updateSpiderSubscription);
    this.events.unsubscribe("beer-detail:update:beer-spider", this.updateSpiderSubscription);
  }

  initValues() {
    //TODO check that the colors are in the correct order!
    //this.colors = ["#FFFFCD", "#FFFF01", "#FE9900", "#A94124", "#5B220E", "#FFC000", "#CC6601", "#CC0001", "#080808"];
    this.colors = ["#FFFFCD", "#FFFF01", "#FFCC00", "#FE9900", "#CC6601", "#A94214", "#CC0001", "#5B220E", "#080808"];

    //this.colorIndex = 0;
//    this._color = -1;//index, not value
//    this._clarity = -1;//index, not value
  }

  initPoints() {
    this.points[0] = [
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 }
    ];

    this.points[1] = [
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 }
    ];

    this.points[2] = [
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 }
    ];

    this.points[3] = [
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 }
    ];

    this.points[4] = [
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 },
      { x: 0, y: 0 }
    ];

    //console.dir(this.points);
  }

  initCanvas() {
    if (this._CANVAS.getContext) {
      this.setupCanvas();
    }
  }

  setupCanvas() {
    this._CONTEXT = this._CANVAS.getContext('2d');
    this._CONTEXT.fillStyle = "#ffffff";//"#ccffee";
    this._CONTEXT.fillRect(0, 0, this.w, this.h);
  }

  clearCanvas() {
    if (!this.initDone) {
      //console.log("[beer-spider] initDone NO => returning...");
      return;
    }

    this._CONTEXT.clearRect(0, 0, this._CANVAS.width, this._CANVAS.height);
    this.setupCanvas();

    let centerX = this.w / 2.0;
    let centerY = this.h / 2.0;

    this.middleX = centerX;
    this.middleY = centerY;

    //calculate all sizes

    let outerRadius = 12 * this.w / 35;//was 10

    let hexHeight = Math.sqrt(3.0) * outerRadius;

    let canvHeight = 5 * hexHeight / 3;

    if (canvHeight > this.h) {
      //console.log("canvas too high, working the other way around...");
      //omgekeerd te werk gaan
      hexHeight = 3 * this.h / 5;
      outerRadius = hexHeight / Math.sqrt(3.0);
    }
    this.drawSvg();
  }

  public drawSvg() {
    if (this.initDone) {
      let analysis = {
        fruity: (this.baseFlavors.fruity > 0 ? this.baseFlavors.fruity : 0),
        malty: (this.baseFlavors.malty > 0 ? this.baseFlavors.malty/* - 1*/ : 0),
        sweet: (this.baseFlavors.sweet > 0 ? this.baseFlavors.sweet/* - 1*/ : 0),
        sour: (this.baseFlavors.sour > 0 ? this.baseFlavors.sour/* - 1*/ : 0),
        bitter: (this.baseFlavors.bitter > 0 ? this.baseFlavors.bitter/* - 1*/ : 0),
        hoppy: (this.baseFlavors.hoppy > 0 ? this.baseFlavors.hoppy/* - 1*/ : 0),
        color: this.baseFlavors.color,
        colourRGB: (this.baseFlavors.color > 0 ? this.colors[this.baseFlavors.color - 1] : '#ffffff')
      }
      let svgResult = this.svgProvider.generateSpider(analysis, 0, 0, Math.trunc(this.w), Math.trunc(this.h));

      let contentArray: Array<any> = svgResult.content;

      contentArray.forEach((value: any, index: number, array: any[]) => {
        let name: string = value.name;
        let content: string = value.value;

        if (content && content != null) {
          //console.log('beer-spider: found content for ' + name + ': ' + content);
          let mySvgRoot: jQuery<HTMLElement> = $('#' + name);
          //console.log('beer-spider: id = ' + $('#' + name).attr('id'));
          //$('#' + name).empty();
          //$('#' + name).append(content);
          //console.log('beer-spider: inner content is = ' + $('#' + name));
          //$('#' + name).show();
        }
        else {
          //console.log('beer-spider: no content for ' + name);
        }
      });
      let de_som = analysis.fruity + analysis.malty + analysis.hoppy +
          analysis.sour + analysis.sweet + analysis.bitter + analysis.color;
      console.log("BeerSpiderComponent.drawSvg: flavor_sum = " + de_som + ", " + this.svgSpiderContents);
      if (de_som <= 0) {
        console.log("BeerSpiderComponent.drawSvg: drawing empty spider");
      }
      this.svgHexagons.innerHTML = svgResult.svgHexagons;
      this.svgSpiderContents.innerHTML = svgResult.svgSpiderContents;
      this.svgSpiderTouchOverlay.innerHTML = svgResult.svgSpiderTouchOverlay;
    }
    else {
      console.log("BeerSpiderComponent.drawSvg: init not done");
    }
  }

  ngOnInit() {
    this.events.subscribe("beer-detail:update:beer-spider", this.updateSpiderSubscription);
    this.events.subscribe("update:spider", this.updateSpiderSubscription);
  }
  ngAfterViewInit() {
    console.log("BeerSpiderComponent.ngAfterViewInit called")
    // MUST be in afterViewInit because the view must exist
    // MUST use the timeout trick to enforce updating in a next eventloop iteration
    setTimeout(() => { this.initializeView();this.drawSvg(); }, 0);
//    this.initializeView();
//    this.drawSvg();
  }

  initializeView() {

    if (!this.initDone) {
      //console.log("[beer-spider] size of window: " + window.innerWidth + " x " + window.innerHeight);

      this._CANVAS = this.spiderCanvas.nativeElement;

      this.svgHexagons = this.svgHexagonsRef.nativeElement;
      this.svgSpiderContours = this.svgSpiderContoursRef.nativeElement;
      this.svgSpiderContents = this.svgSpiderContentsRef.nativeElement;
      this.svgSpiderTouchOverlay = this.svgSpiderTouchOverlayRef.nativeElement;

      this.w = window.innerWidth * 0.7;
      this._CANVAS.width = this.w;

      this.h = window.innerWidth * 0.6;
      this._CANVAS.height = this.h;

      this.initCanvas();

      //let widthCount = 7;
      //let heightCount = 5;

      //let unitWidth = this.w / widthCount;
      //let unitHeight = this.h / heightCount;

      let centerX = this.w / 2.0;
      let centerY = this.h / 2.0;

      this.middleX = centerX;
      this.middleY = centerY;

      //calculate all sizes

      let outerRadius = 12 * this.w / 35;//was 10

      let hexHeight = Math.sqrt(3.0) * outerRadius;

      let canvHeight = 5 * hexHeight / 3;

      if (canvHeight > this.h) {
        //console.log("canvas too high, working the other way around...");
        //omgekeerd te werk gaan
        hexHeight = 3 * this.h / 5;
        outerRadius = hexHeight / Math.sqrt(3.0);
      }

      //console.log("radius is " + outerRadius);

      this.initDone = true;
    }
  }

  //draw the different labels, outside of the radar chart
  drawLabels() {

    //let imageWidth = 30;
    //let imageHeight = 30;

    //fruity
    let str = "fruity";

    let point = this.points[0][RadarIndex.INDEX_FRUITY];
    let x = point.x;// - 0.75 * imageWidth;//was -imageWidth
    let y = point.y;//+ imageHeight / 2;

    this.DrawString(this._CONTEXT, str, x - 40, y + 20, "#000000", null, null, 16);
    //canvas.drawText(text, x /*- xOffset*/, y + bounds.height() /*textHeight*/, mTextPaint);

    // sour
    str = "sour";

    point = this.points[0][RadarIndex.INDEX_SOUR];
    x = point.x;// - 0.75 * imageWidth;//was -imageWidth
    y = point.y;//+ imageHeight / 2;

    this.DrawString(this._CONTEXT, str, x, y + 20, "#000000", null, null, 16);

    // malty
    str = "malty";

    point = this.points[0][RadarIndex.INDEX_MALTY];
    x = point.x;// - 0.75 * imageWidth;//was -imageWidth
    y = point.y;//+ imageHeight / 2;

    this.DrawString(this._CONTEXT, str, x - 60, y + 20, "#000000", null, null, 16);

    // sweet
    str = "sweet";

    point = this.points[0][RadarIndex.INDEX_SWEET];
    x = point.x;// - 0.75 * imageWidth;//was -imageWidth
    y = point.y;//+ imageHeight / 2;

    this.DrawString(this._CONTEXT, str, x + 15, y + 20, "#000000", null, null, 16);

    // hoppy
    str = "hoppy";
    point = this.points[0][RadarIndex.INDEX_HOPPY];
    x = point.x;// - 0.75 * imageWidth;//was -imageWidth
    y = point.y;//+ imageHeight / 2;

    this.DrawString(this._CONTEXT, str, x - 70, y - 10, "#000000", null, null, 16);

    // bitter
    str = "bitter";

    point = this.points[0][RadarIndex.INDEX_BITTER];
    x = point.x;// - 0.75 * imageWidth;//was -imageWidth
    y = point.y;//+ imageHeight / 2;

    this.DrawString(this._CONTEXT, str, x + 15, y - 10, "#000000", null, null, 16);

  }

  //draw a string at a specific position, with a specific color, rotation, font (size)
  private DrawString(ctx, text, posX, posY, textColor, rotation, font, fontSize) {

    let lines = text.split("\n");
    if (!rotation)
      rotation = 0;
    // if (!font)
    font = "'Century Gothic Bold'";
    if (!fontSize)
      fontSize = 16;
    //fontSize = 16;
    if (!textColor)
      textColor = '#000000';

    ctx.save();

    ctx.font = fontSize + "px " + font;

    ctx.fillStyle = textColor;

    ctx.translate(posX, posY);

    ctx.rotate(rotation * Math.PI / 180);

    for (let i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i], 0, i * fontSize);
    }
    ctx.restore();
  }

  //draw the different images, representing the different aromas
  drawImages() {

    //x coord of image
    let x: number = 0;
    //y coord of image
    let y: number = 0;
    //path of image to show
    let path: String = '';
    //width of image
    let width: number = 35;
    //height of image
    let height: number = 35;

    //malty
    //position: OK
    let point = this.points[0][RadarIndex.INDEX_MALTY];

    x = point.x;
    y = point.y;
    path = 'assets/svg/icon_aroma_malty.svg';
    width = 35;
    height = 35;
    this.DrawImage(this._CONTEXT, x, y, path, width, height);


    //sweet
    //position: had to move a bit to the right (trial/error)
    point = this.points[0][RadarIndex.INDEX_SWEET];
    x = point.x + 35;
    y = point.y;
    path = 'assets/svg/icon_taste_sweet.svg';
    width = 35;
    height = 35;
    this.DrawImage(this._CONTEXT, x, y, path, width, height);


    //sour
    //position: had to move a bit to the right (trial/error)
    point = this.points[0][RadarIndex.INDEX_SOUR];
    x = point.x + 25;
    y = point.y;
    path = 'assets/svg/icon_taste_sour.svg';
    width = 35;
    height = 35;
    this.DrawImage(this._CONTEXT, x, y, path, width, height);


    //bitter
    //postion: had to move a bit to the right (trial/error) AND down (trial/error)
    point = this.points[0][RadarIndex.INDEX_BITTER];
    x = point.x + 35;
    y = point.y + 20;
    path = 'assets/svg/icon_taste_bitter.svg';
    width = 35;
    height = 35;
    this.DrawImage(this._CONTEXT, x, y, path, width, height);


    //fruity
    point = this.points[0][RadarIndex.INDEX_FRUITY];
    x = point.x - 15;
    y = point.y;
    path = 'assets/svg/icon_aroma_fruity.svg';
    width = 35;
    height = 35;
    this.DrawImage(this._CONTEXT, x, y, path, width, height);

    //hoppy
    point = this.points[0][RadarIndex.INDEX_HOPPY];
    x = point.x - 15;
    y = point.y + 20;
    path = 'assets/svg/icon_aroma_hoppy.svg';
    width = 35;
    height = 35;
    this.DrawImage(this._CONTEXT, x, y, path, width, height);

  }

  private DrawImage(ctx: CanvasRenderingContext2D, x: number, y: number, path: String, width: number, height: number) {
    (function (_ctx, _x, _y, _path, _width, _height) {
      let im = new Image();
      im.src = _path;
      im.onload = function () {
        let sizeModifier = .75;
        //let imSize = _width * 2;
        _ctx.drawImage(im, _x - (_width * sizeModifier), _y - (_height * sizeModifier), _width, _height);
      }.bind(this);
    }.bind(this))(ctx, x, y, path, width, height);
  }

  plotData() {
    console.log("plotdata");
    if (!this.initDone) {
      console.log("not yet inited");
      //return;
    }
    //lines from the middle to the different points

    let ctx = this._CONTEXT;

    ctx.beginPath();

    //this.points contains the (x,y) for all hexagons
    //choose one to start with, e.g. FRUITY

    let xPos: number = 0;
    let yPos: number = 0;

    let fruityChanged = 0;
    if (this.baseFlavors.fruity == 0 || this.baseFlavors.fruity == 1)
      fruityChanged = 0;
    else
      fruityChanged = this.baseFlavors.fruity - 1;

    xPos = this.points[4 - fruityChanged][RadarIndex.INDEX_FRUITY].x;
    yPos = this.points[4 - fruityChanged][RadarIndex.INDEX_FRUITY].y;
    //console.log('1 - x: ' + xPos + " - y: " + yPos);

    ctx.moveTo(xPos, yPos);

    let maltyChanged = 0;
    if (this.baseFlavors.malty == 0 || this.baseFlavors.malty == 1)
      maltyChanged = 0;
    else
      maltyChanged = this.baseFlavors.malty - 1;

    xPos = this.points[4 - maltyChanged][RadarIndex.INDEX_MALTY].x;
    yPos = this.points[4 - maltyChanged][RadarIndex.INDEX_MALTY].y;
    //console.log('2 - x: ' + xPos + " - y: " + yPos);
    ctx.lineTo(xPos, yPos);

    let sweetChanged = 0;
    if (this.baseFlavors.sweet == 0 || this.baseFlavors.sweet == 1)
      sweetChanged = 0;
    else
      sweetChanged = this.baseFlavors.sweet - 1;

    xPos = this.points[4 - sweetChanged][RadarIndex.INDEX_SWEET].x;
    yPos = this.points[4 - sweetChanged][RadarIndex.INDEX_SWEET].y;
    //console.log('3 - x: ' + xPos + " - y: " + yPos);
    ctx.lineTo(xPos, yPos);

    let sourChanged = 0;
    if (this.baseFlavors.sour == 0 || this.baseFlavors.sour == 1)
      sourChanged = 0;
    else
      sourChanged = this.baseFlavors.sour - 1;

    xPos = this.points[4 - sourChanged][RadarIndex.INDEX_SOUR].x;
    yPos = this.points[4 - sourChanged][RadarIndex.INDEX_SOUR].y;
    //console.log('4 - x: ' + xPos + " - y: " + yPos);
    ctx.lineTo(xPos, yPos);

    let bitterChanged = 0;
    if (this.baseFlavors.bitter == 0 || this.baseFlavors.bitter == 1)
      bitterChanged = 0;
    else
      bitterChanged = this.baseFlavors.bitter - 1;

    xPos = this.points[4 - bitterChanged][RadarIndex.INDEX_BITTER].x;
    yPos = this.points[4 - bitterChanged][RadarIndex.INDEX_BITTER].y;
    //console.log('5 - x: ' + xPos + " - y: " + yPos);
    ctx.lineTo(xPos, yPos);

    let hoppyChanged = 0;
    if (this.baseFlavors.hoppy == 0 || this.baseFlavors.hoppy == 1)
      hoppyChanged = 0;
    else
      hoppyChanged = this.baseFlavors.hoppy - 1;

    xPos = this.points[4 - hoppyChanged][RadarIndex.INDEX_HOPPY].x;
    yPos = this.points[4 - hoppyChanged][RadarIndex.INDEX_HOPPY].y;
    //console.log('6 - x: ' + xPos + " - y: " + yPos);
    ctx.lineTo(xPos, yPos);

    xPos = this.points[4 - fruityChanged][RadarIndex.INDEX_FRUITY].x;
    yPos = this.points[4 - fruityChanged][RadarIndex.INDEX_FRUITY].y;
    //console.log('7 - x: ' + xPos + " - y: " + yPos);

    ctx.lineTo(xPos, yPos);

    if (this.baseFlavors.color == -1) {
      //do not fill
      //nothing to do...

    }
    else {
      console.log("color index is " + this.baseFlavors.color + ", drawing with color " + this.colors[this.baseFlavors.color - 1]);
      ctx.fillStyle = this.colors[this.baseFlavors.color - 1];

      //ctx.save();
      ctx.globalAlpha = 0.8;
      ctx.fill();

    }

    //ctx.restore();

    ctx.strokeStyle = "#ffdd58";
    ctx.lineWidth = 2.5;
    ctx.stroke();
  }

  drawCenterLines() {
    //lines from the middle to the different points

    let ctx = this._CONTEXT;

    ctx.beginPath();

    for (let cornerIndex = 0; cornerIndex < 6; cornerIndex++) {
      ctx.moveTo(this.middleX, this.middleY);

      let cornerX = this.points[0][cornerIndex].x;
      let cornerY = this.points[0][cornerIndex].y;

      ctx.lineTo(cornerX, cornerY);
    }

    ctx.strokeStyle = "#333333";
    ctx.lineWidth = .5;
    ctx.stroke();
  }

  drawHex(centerX: number, centerY: number, radius: number, index: number) {

    let ctx = this._CONTEXT;
    let x = centerX;
    let y = centerY;

    let sideIndex: number = 0;

    let theradius = radius;

    ctx.beginPath();

    let xPos = x + theradius * Math.cos(0);
    let yPos = y + theradius * Math.sin(0);
    this.points[index][0].x = xPos;
    this.points[index][0].y = yPos;

    ctx.moveTo(x + theradius * Math.cos(0), y + theradius * Math.sin(0));

    //Draw hexagon sides
    for (let side = 0; side < 7; side++) {
      ctx.lineTo(x + theradius * Math.cos(side * 2 * Math.PI / 6), y + theradius * Math.sin(side * 2 * Math.PI / 6));

      xPos = x + theradius * Math.cos(side * 2 * Math.PI / 6);
      yPos = y + theradius * Math.sin(side * 2 * Math.PI / 6);
      if (side < 6) {
        //let sideIndex = 0;//side;
        //console.log("working for sideIndex " + sideIndex);
        this.points[index][sideIndex].x = xPos;
        this.points[index][sideIndex].y = yPos;
      }
      sideIndex++;
    }

    //pick fill type
    /*if (isSelected) {
      ctx.fillStyle = "#ffdd58";
      ctx.fill();
    }*/

    ctx.strokeStyle = "#333333";
    ctx.lineWidth = .5;
    if (index == 0)
      ctx.lineWidth = 1;
    ctx.stroke();

  }

  private svgElementStart() {
    return '<svg xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/"' +
      ' xmlns:dc="http://purl.org/dc/elements/1.1/"' +
      ' xmlns:cc="http://creativecommons.org/ns#"' +
      ' xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"' +
      ' xmlns:svg="http://www.w3.org/2000/svg"' +
      ' xmlns="http://www.w3.org/2000/svg"' +
      ' xmlns:xlink="http://www.w3.org/1999/xlink"' +
      ' xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"' +
      ' id="spider-svg-svg" version="1.1" ' + this.svgViewAttributes(0, 0, this.w, this.h) + '>';
  }
  private svgViewAttributes(x, y, width, height) {
    return 'viewBox="' + x + ' ' + y + ' ' + width + ' ' + height + '"' +
      ' " height="' + height + '" width="' + width + '"';
  }

  getW() {
    return this.w;
  }

  getH() {
    return this.h;
  }

  getHRV(value: number) {
    return value / 1152 * this.getH();
  }

  getWRV(value: number) {
    return value / 1344 * this.getW();
  }

  getTRV(value: number) {
    return value / (1152 * 1344) * (this.getW() * this.getH());

  }


}
